import * as React from 'react';
import { Query } from 'react-apollo';

import type { ApolloError } from 'apollo-client';
import type { Duration } from 'moment';

import courseAccomplishmentsPageQuery from 'bundles/accomplishments/queries/CourseAccomplishmentsPageQuery.graphql';
import type {
  CourseAccomplishmentsPageQuery as CourseAccomplishmentsPageQueryResponse,
  CourseAccomplishmentsPageQueryVariables,
} from 'bundles/accomplishments/queries/__generated__/CourseAccomplishmentsPageQuery';

type ProductMetricState = {
  loading: boolean;
  error?: ApolloError;
  enrollmentCount?: number;
  duration?: Duration;
};

type Props = {
  slug: string;
  specializationSlug?: string;
  children: (data: ProductMetricState) => JSX.Element;
};

const CourseAccomplishmentsDataProvider = ({ slug, specializationSlug, children }: Props) => {
  return (
    <Query<CourseAccomplishmentsPageQueryResponse, CourseAccomplishmentsPageQueryVariables>
      query={courseAccomplishmentsPageQuery}
      variables={{ slug, specializationSlug }}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {({ loading, error, data }) => {
        const totalEnrollmentCount = data?.DescriptionPage?.queryCoursePage?.totalEnrollmentCount || 0;
        const totalDuration = data?.DescriptionPage?.queryCoursePage?.material?.totalDuration;
        // @ts-expect-error Duration: string
        return children({ loading, error, enrollmentCount: totalEnrollmentCount, duration: totalDuration });
      }}
    </Query>
  );
};

export default CourseAccomplishmentsDataProvider;
